import * as React from "react";
import styled, { css } from "../../../styled/index";
import {shadeAlternate} from "../../../styled/helpers";
import {CS} from "../../../styles/index";
import autobind from "autobind-decorator";

type DropDirections = "top" | "bottom";
type DropFlow = "left" | "right";

const ClickOutComponent = require("react-onclickout");

export const Wrapper = styled("div")`
  position: relative;
`;

export const ChildContent = styled("div")`
  cursor: pointer;
`;

interface DropDownProps {
  active: boolean;
  direction?: DropDirections;
  flow?: DropFlow;
  width?: number;
  offset?: number;
}

export const Dropdown = styled("div")<DropDownProps>`
  position: absolute;
  display: ${({active}) => active ? "block" : "none"};
  height: auto;
  min-width: ${({width}) => width ? `${width}px` : "100px"};
  width: ${({width}) => width ? `${width}px` : "100%"};
  border-radius: 5px;
  background: ${({theme}) => theme.box.background};
  color: ${({theme}) => theme.box.text};
  ${CS.shadow.heavy.one};
  z-index: 12;
  ${({ direction, offset }) => direction === "top" ? css`
    bottom: calc(100% + ${offset || "4"}px);
  ` : css`
    top: calc(100% + ${offset || "4"}px);
  `}
  ${({flow}) => flow === "left" ? css`
    right: 0;
  ` : css`
    left: 0;
  `}
`;

export const Content = styled("div")`
  display: flex;
  flex-direction: column;
  border: 1px solid #dfdfdf;
  border-radius: 5px;
`;

interface Props {
  active: boolean;
  open: () => void;
  close: () => void;
  children: React.ReactNode;
  content: React.ReactNode;
  direction?: DropDirections;
  flow?: DropFlow;
  width?: number;
  offset?: number;
}

interface State {}

export class DropDown extends React.Component<Props, State> {

  clickOutActive: boolean = false;

  constructor(props: Props) {
    super(props);
    this.state = {};
  }

  onClickOut = () => {
    if (this.props.active && this.clickOutActive) {
      this.props.close();
    }
  }

  componentDidUpdate() {
    setTimeout(() => {
      this.clickOutActive = this.props.active;
    }, 100);
  }

  render() {
    const { active, open, content, children, direction, flow, width, offset } = this.props;
    return (
      <Wrapper>
        <ChildContent onClick={open}>
          {children}
        </ChildContent>
        <ClickOutComponent onClickOut={this.onClickOut}>
          <Dropdown active={active} direction={direction} flow={flow} width={width} offset={offset}>
            <Content>
              {content}
            </Content>
          </Dropdown>
        </ClickOutComponent>
      </Wrapper>
    );
  }

}
